// extracted by mini-css-extract-plugin
export default {"container":"styles__container___XiMi6","content":"styles__content___vwcbG","logoWrapper":"styles__logoWrapper___i9gy+"};